import { z } from "zod";

export const EmailSchema = z.string().trim().toLowerCase().email("Geçerli bir e-posta girin").max(254);
export const PasswordSchema = z.string().min(8, "Parola en az 8 karakter olmalı").max(200);

export const RegisterBodySchema = z.object({
  email: EmailSchema,
  password: PasswordSchema,
  name: z.string().trim().min(1, "Ad gerekli").max(120),
  chamberNo: z.string().trim().max(40).optional(),
  org: z.string().trim().max(120).optional(),
});
export type RegisterBody = z.infer<typeof RegisterBodySchema>;

/** remember false → tarayıcı oturumu çerezi (sunucuda en çok 1 gün); yok/true → 30 gün. */
export const LoginBodySchema = z.object({ email: EmailSchema, password: z.string().min(1).max(200), remember: z.boolean().optional() });
export type LoginBody = z.infer<typeof LoginBodySchema>;

export const ForgotBodySchema = z.object({ email: EmailSchema });
export const ResetBodySchema = z.object({ token: z.string().min(1), password: PasswordSchema });
export const DeleteMeBodySchema = z.object({ password: z.string().max(200).optional() });

/** Fatura bilgileri (isteğe bağlı; ödeme onayında yöneticiye gösterilir, fatura kesimi için). */
export const BillingInfoSchema = z.object({
  kind: z.enum(["individual", "company"]).default("individual"),
  title: z.string().max(200).default(""),        // ad soyad ya da ticaret unvanı
  taxOffice: z.string().max(100).default(""),
  taxNo: z.string().max(40).default(""),         // TCKN ya da vergi no
  address: z.string().max(400).default(""),
  email: z.string().max(120).default(""),        // e-fatura / e-arşiv e-postası (boşsa hesap e-postası)
});
export type BillingInfo = z.infer<typeof BillingInfoSchema>;

export const UpdateMeBodySchema = z.object({
  name: z.string().min(1).max(120).optional(),
  chamberNo: z.string().max(40).nullable().optional(),
  org: z.string().max(200).nullable().optional(),
  billing: BillingInfoSchema.nullable().optional(),
});
export type UpdateMeBody = z.infer<typeof UpdateMeBodySchema>;

export const UserDtoSchema = z.object({
  id: z.string().uuid(),
  email: z.string(),
  name: z.string(),
  chamberNo: z.string().nullable(),
  org: z.string().nullable(),
  role: z.enum(["user", "admin"]),
  emailVerified: z.boolean(),
  createdAt: z.string(),
  billing: BillingInfoSchema.nullable().optional(),
  /** WhatsApp ile doğrulanmış numara var mı */
  phoneVerified: z.boolean().optional(),
});
export type UserDto = z.infer<typeof UserDtoSchema>;

/** free: hiç abonelik yok (ücretsiz hesap); expired: ücretli/deneme süresi bitmiş — ikisi de ücretsiz katman haklarıyla çalışır. */
export const SubscriptionStatusSchema = z.enum(["free", "trialing", "active", "past_due", "expired"]);
export type SubscriptionStatus = z.infer<typeof SubscriptionStatusSchema>;

export const SubscriptionDtoSchema = z.object({
  status: SubscriptionStatusSchema,
  planCode: z.string().nullable(),
  planName: z.string().nullable(),
  endsAt: z.string().nullable(),
  daysLeft: z.number().int().nullable(),
  canWrite: z.boolean(),
  canExport: z.boolean(),
  watermark: z.string().nullable(),
  /** Ücretsiz katmanda false: yalnız kontrol sonucu (GK + sağlıyor/sağlamıyor); hesap ayrıntısı, rapor, çıktı, paylaşım, boyutlandırma, AI kapalı. */
  fullAccess: z.boolean().default(true),
  /** Ücretsiz katmanda buluttaki proje sınırı; null = sınırsız. */
  maxProjects: z.number().int().nullable().default(null),
});
export type SubscriptionDto = z.infer<typeof SubscriptionDtoSchema>;

/** phoneRequired: WhatsApp doğrulaması açık ve bu kullanıcı (ücretsiz katman, numarasız) proje kaydetmeden önce doğrulamalı. */
export const MeResponseSchema = z.object({ user: UserDtoSchema, subscription: SubscriptionDtoSchema, phoneRequired: z.boolean().default(false) });
export type MeResponse = z.infer<typeof MeResponseSchema>;
